import {
  ExtendedAccordion,
  ExtendedAccordionProps
} from "../ExtendedAccordion";
export const Accordion = ExtendedAccordion;
export interface AccordionProps extends ExtendedAccordionProps {}
